export const EMAIL_FORMAT_ERROR = "Saisissez une adresse e-mail valide, par exemple nom@domaine.fr"

export const SIRET_KEY_ERROR = "Le numéro de SIRET saisi n’est pas valide. Vérifiez les 14 chiffres sur l’avis de situation Insee ou l’annuaire des entreprises"

export const EMAIL_FORMAT_HINT = "Format attendu : nom@domaine.fr"

export const PHONE_FORMAT_ERROR = "Saisissez un numéro de téléphone à 10 chiffres, par exemple 0612345678"

export const PHONE_FORMAT_HINT = "10 chiffres, par exemple 0612345678"

// Sans « déjà associé » : CustomInput ajouterait un lien « Connexion », hors sujet quand on saisit l’adresse d’un tiers
export const EMAIL_ALREADY_USED_ERROR = "Cette adresse e-mail est déjà utilisée par un autre compte La bonne alternance. Saisissez une autre adresse, par exemple nom@domaine.fr"
